export default class StatusFactory {
  Enable = 1
  Disable = 0
  emptyPhone = 1001
  checkForceBindPhone = 1002
  weChatAuthFail = 1003
  checkFollowOfficialAccounts = 1004
}
